import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ZRSwitchField from '@zr/components/Fields/ZRSwitchField';

import './RDBSection.less';

import { RDB_OPT_IN_TOOLTIP } from '@zr/jobseeker-public/apps/jobseeker-screens/labels';

export function RDBSection({
  disabled, onChange,
}) {
  const [value, setValue] = useState(true);

  const handleChange = (event) => {
    setValue(event.target.checked);
    onChange(event.target.checked);
  };

  return (
    // just rdb_section/RDBSection might clash with existing classes
    <section className="ProfileApprovalRDBSection">
      <ZRSwitchField
        label="Let Employers Find You"
        input={{
          disabled,
          name: 'rdb_optin',
          onChange: handleChange,
          value,
        }}
        tooltip={RDB_OPT_IN_TOOLTIP}
        buttonLeftOfLabel={false}
      />
      <p className="description">
        {value
          ? 'Public: Hiring managers will be able to view your profile and reach out about potential opportunities.'
          : 'Private: Your profile is not publicly accessible. However, it is viewable as a part of your applications.'}
      </p>
    </section>
  );
}

RDBSection.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

RDBSection.defaultProps = {
  disabled: false,
};

export default RDBSection;
